import React from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';

import Home from '../pages/Home';
import Prices from '../pages/Prices';
import Budgets from '../pages/Budgets';
import BudgetsRegister from '../pages/BudgetsRegister';
import Clients from '../pages/Clients';
import ClientsRegister from '../pages/ClientsRegister';
import Standards from '../pages/Standards';
import FAQ from '../pages/FAQ';
import Register from '../pages/Register';
import Login from '../pages/Login';
import LoginForget from '../pages/LoginForget';
import Editions from '../pages/Editions';
import Search from '../pages/Search';

const Routes: React.FC = () => {
  return (
    <Switch>
      <Route path="/" component={Home} exact />
      <Route path="/standards" component={Standards} />
      <Route path="/faq" component={FAQ} />
      <Route path="/prices" component={Prices} />
      <Route path="/register" component={Register} />
      <Route path="/login" component={Login} />
      <Route path="/login-forget" component={LoginForget} />
      <Route path="/editions" component={Editions} />
      <Route path="/search" component={Search} />

      <Route path="/budgets" exact component={Budgets} isPrivate />
      <Route path="/budgets/register" component={BudgetsRegister} isPrivate />
      <Route
        path="/budgets/:id/:action"
        component={BudgetsRegister}
        isPrivate
      />
      <Route path="/budgets/:id" component={BudgetsRegister} isPrivate />
      <Route path="/clients" exact component={Clients} isPrivate isAgency />
      <Route
        path="/clients/register"
        component={ClientsRegister}
        isPrivate
        isAgency
      />
    </Switch>
  );
};

export default Routes;
